import PrintTemplate from "../../../../components/reports/print-reports/print-template.jsx";
import ReportContent from "./report-content.jsx";
import CitizenHistoryActions from "../../../web/sos/citizen-history/utils/citizen-history-actions.js";

export default function Content({reportData, data, entity, title, printComponentRef, setIsPrinting, filters}) {
    const labels = {history_actions: "Ação", dtStart: "Data inicial", dtEnd: "Data final", target: "Cidadão/Empresa", username: "Cadastrado por", description: "Descrição"};
    const activeFilters = Object.entries(filters).filter(([key]) => labels[key]).map(([key, value]) => {
        if (key === "history_actions") value = CitizenHistoryActions.toView(value);
        if (key === "dtStart" || key === "dtEnd") value = new Intl.DateTimeFormat("pt-BR", {timeZone: "UTC"}).format(new Date(value));
        return [key, value];
    });
    if (!reportData || !data) return null;

    return (
        <PrintTemplate
            entity={entity}
            title={title}
            ref={printComponentRef}
            setIsPrinting={setIsPrinting}
        >
            <div className="transform !-translate-y-[8.5px]"/>
            {activeFilters.length > 0 && (
                <>
                    <div id="filters-print" className="hidden print:block transform !-translate-y-[8.5px] text-sm">
                        <span className="font-semibold">Filtros:</span>{" "}
                        {activeFilters.map(([key, value]) => labels[key] + ": " + value).join(" | ")}
                    </div>

                    <div className="print:border-b print:border-gray-200 print:mb-6 print:w-full"/>
                </>
            )}
            <div className="w-full mt-[25px] print:mt-0">
                <ReportContent history={reportData.history}/>
            </div>
        </PrintTemplate>
    );
}
